export default __webpack_public_path__ + "static/media/inquadratura.15a437ec.png";